
import Vue from "vue";
import Modal from "@/components/Modal.vue";
import Typography from "@/components/Typography.vue";
import RoundButton from "@/components/RoundButton.vue";
import { TASK } from "@/store/task";
import { APPLICATION } from "@/store/applications";
import { APPLICATION_ACTIONS } from "@/store/applications/actions";
import store from "@/store";

export default Vue.extend({
  components: {
    Modal,
    Typography,
    RoundButton
  },
  computed: {
    showModal: {
      get(): boolean {
        return store.state.application.showAssignToMeConfirmation;
      },
      set(value: boolean) {
        this.$store.dispatch(
          APPLICATION.NS(APPLICATION_ACTIONS.CLOSE_ASSIGN_TO_ME_CONFIRMATION)
        );
      }
    },
    task() {
      return store.state.tasks.applicationTimeline[0];
    }
  },
  methods: {
    async onYes() {
      await store.dispatch(TASK.NS(TASK.ACTIONS.ASSIGN_TASK), this.task);
      this.$store.dispatch(
        APPLICATION.NS(APPLICATION_ACTIONS.CLOSE_ASSIGN_TO_ME_CONFIRMATION)
      );
    }
  }
});
